/* =========================================================
   evr-xpill.js
   - Toggles EVR XPill open/close state
   - Works with event delegation (safe for theme blocks)
   ========================================================= */

(function () {
  function setOpen(xpill, open) {
    if (!xpill) return;

    const btn = xpill.querySelector("[data-evr-xpill-btn]") || xpill.querySelector(".evr-xpill__btn");
    const panel = xpill.querySelector(".evr-xpill__body");

    xpill.classList.toggle("is-open", open);

    if (btn) btn.setAttribute("aria-expanded", open ? "true" : "false");

    if (panel) {
      if (open) panel.removeAttribute("hidden");
      else panel.setAttribute("hidden", "");
    }
  }

  // Initialize any pills that render "open" in Liquid (class already present)
  function initExisting() {
    document.querySelectorAll(".evr-xpill").forEach((xpill) => {
      const open = xpill.classList.contains("is-open");
      setOpen(xpill, open);
    });
  }

  // Click handler (delegated) — toggle by clicking the whole pill (safe)
  document.addEventListener("click", (e) => {
    // 1) Find the xpill that was clicked
    const xpill = e.target.closest(".evr-xpill");
    if (!xpill) return;

    // 2) Ignore clicks on interactive elements inside the pill content
    //    (so links, inputs, selects, etc. still work)
    const interactive = e.target.closest(
      'a, button, input, textarea, select, label, summary, details, [role="button"], [contenteditable="true"]'
    );
    // If the click is on an interactive element AND it's not the xpill toggle button,
    // do not toggle the pill.
    const isToggleBtn = e.target.closest("[data-evr-xpill-btn], .evr-xpill__btn");
    if (interactive && !isToggleBtn) return;

    // 3) If you only want clicks on the "header area" (not the body) to toggle,
    //    uncomment this block (recommended if your body contains lots of text/links)
    /*
    const body = xpill.querySelector(".evr-xpill__body");
    if (body && body.contains(e.target) && !isToggleBtn) return;
    */

    const willOpen = !xpill.classList.contains("is-open");

    // Scope: close others inside nearest xpill container
    let scope =
      xpill.closest("[data-evr-xpill-scope]") ||
      (function findNearestMultiPillContainer(node) {
        let cur = node.parentElement;
        while (cur) {
          const pills = cur.querySelectorAll(":scope .evr-xpill");
          if (pills.length > 1) return cur;
          cur = cur.parentElement;
        }
        return document;
      })(xpill);

    if (willOpen) {
      scope.querySelectorAll(".evr-xpill.is-open").forEach((other) => {
        if (other !== xpill) setOpen(other, false);
      });
    }

    setOpen(xpill, willOpen);
  });

  // Keyboard: Enter/Space on the button should toggle (some themes interfere)
  document.addEventListener("keydown", (e) => {
    if (e.key !== "Enter" && e.key !== " ") return;

    const btn = e.target.closest("[data-evr-xpill-btn], .evr-xpill__btn");
    if (!btn) return;

    e.preventDefault();
    btn.click();
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initExisting);
  } else {
    initExisting();
  }
})();
